import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateShippingStatus } from "../api/statusService";

export type TrackingSubmission = {
  trackingInfo: { trackingNumber: string; carrier: string };
  trackingImage: File | null;
};

export const useUpdateShippingStatus = (
  orderId: string,
  { onSuccess }: { onSuccess?: () => void } = {},
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ trackingInfo, trackingImage }: TrackingSubmission) =>
      updateShippingStatus(orderId, trackingInfo, trackingImage),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ["order", orderId] });
      onSuccess?.();
    },
  });
};
